module.exports = {"210124001":"吉祥街道","210124002":"龙山街道","210124101":"大孤家子镇","210124102":"三面船镇","210124103":"秀水河子镇","210124104":"叶茂台镇","210124105":"登仕堡子镇","210124106":"柏家沟镇","210124107":"丁家房镇","210124108":"孟家镇","210124109":"十间房镇","210124110":"冯贝堡镇","210124111":"依牛堡子镇","210124113":"包家屯镇","210124201":"慈恩寺乡","210124203":"和平乡","210124208":"四家子蒙古族乡","210124209":"双台子乡","210124210":"卧牛石乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210124.json
// module id = 600
// module chunks = 0